import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Auth from "../../store/ducks/auth.duck";
import { login } from "../../crud/auth.crud";
import * as builder from "../../../_metronic/ducks/builder";
import { useLocation } from "react-router-dom";
import { makeStyles, Grid } from "@material-ui/core";
import { Card, CardHeader, CardContent } from "@material-ui/core";
import clsx from "clsx";
import "../../../_metronic/_assets/css/app.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 850,
    marginTop: 200,
  },
  cardHeader: {
    borderBottom: "solid 1px silver",
    backgroundColor: "#daeaf5",
  },
}));

// import '../../_metronic/_assets/css/app.css';

export default function EmailAuth(props) {
  //

  const [loading, setLoading] = useState(false);
  const [runOnce, setRunOnce] = useState(false);
  const classes = useStyles();
  const ssoStatus = useSelector((state) => state.auth.SSOStatus);

  const enableLoading = () => {
    setLoading(true);
    // setLoadingButtonStyle({ paddingRight: "3.5rem" });
  };

  const disableLoading = () => {
    setLoading(false);
    props.history.push("/home");
    // setLoadingButtonStyle({ paddingRight: "2.5rem" });
  };

  const searchParams = useLocation().search;
  const uid = new URLSearchParams(searchParams).get("uid");
  const page = new URLSearchParams(searchParams).get("page");

  // console.log(uid);
  //console.log(page);

  const username = "device";
  const password = uid;

  const dispatch = useDispatch();

  useEffect(() => {
    if (ssoStatus) {
      checkFormStatus(ssoStatus);
    }
  });

  function checkFormStatus(ssoStatus) {
    if (ssoStatus) {
      setLoading(false);
      // Reset SSO status
      dispatch(Auth.actions.ssoclear());
      // dispatch(Auth.actions.ssoform(page))
      // Back to the main menu
      props.history.push("/dashboard");
    }
  }

  if (!loading && !runOnce) {
    // Prevent the login if not all parameters are present - there is a googlebot pinging this without a membership number
    if (uid) {
      setTimeout(() => {
        dispatch(Auth.actions.ssoclear());
        const browserTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
        setRunOnce(true);
        enableLoading();
        login(username, password, browserTZ)
          .then(
            ({
              data: {
                token,
                refreshToken,
                firstName,
                surname,
                preferredName,
                roleID,
                roleDesc,
                roleScope,
                userTZ,
                winbrowserTZ,
                totp,
                forcePasswordChange,
                providertype,
                recoveryStatus,
                centreName,
                csAgentID,
                centralisedService,
                email,
                mfaConfigured,
                userAdmin,
              },
            }) => {
              dispatch(
                Auth.actions.login(
                  token,
                  refreshToken,
                  firstName,
                  surname,
                  preferredName,
                  roleID,
                  roleDesc,
                  roleScope,
                  userTZ,
                  winbrowserTZ,
                  totp,
                  forcePasswordChange,
                  providertype,
                  recoveryStatus,
                  centreName,
                  csAgentID,
                  centralisedService,
                  email,
                  mfaConfigured,
                  userAdmin,
                ),
              );
              dispatch(builder.actions.setMenuConfig({ roleDesc, roleScope, centralisedService }));
            },
          )
          .catch(() => {
            // it hasn't worked out - need to handle this
            disableLoading();
          });
      }, 1000);
    } else {
      setRunOnce(true);
      // console.log('Variable problems')
      props.history.push("/home");
    }
  }

  return (
    <>
      {loading ? (
        <Grid container justifyContent="center">
          <Card className={classes.root}>
            <CardHeader title="Login In Progress" subheader="" className={classes.cardHeader} />
            <CardContent>
              <Grid container spacing={1}>
                Please wait while we log you in...
                <span
                  className={`ml-3 ${clsx({
                    spinner: loading,
                  })}`}
                />
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ) : null}
    </>
  );
  //
  //
}
